import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import { ContactFilters } from 'src/types';
import qs from 'qs';

export const contactsUrl = '/Contacts';

const ApiUrls = {
  contactsUrl: contactsUrl
};

const GetContacts = (data: Partial<ContactFilters>) =>
  nzApiAxios.get(contactsUrl, { params: data }).then((response) => response.data);

const GetContactsBlock = (slug: string | undefined) =>
  nzApiAxios.get(contactsUrl + `/${slug}`).then((response) => response.data);

const GetBlockCards = (data: Partial<ContactFilters>) =>
  nzApiAxios
    .get(contactsUrl + `/cards`, {
      params: data,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params)
      }
    })
    .then((response) => response.data);

const GetBlocks = () => nzApiAxios.get(contactsUrl + '/blocks').then((response) => response.data);

const GetContactTags = (data: Partial<ContactFilters>) =>
  nzApiAxios.get(contactsUrl + '/tags', { params: data }).then((response) => response.data);

const API = {
  getContacts: GetContacts,
  getBlock: GetContactsBlock,
  getBlockCards: GetBlockCards,
  getBlocks: GetBlocks,
  getTags: GetContactTags
};

export { ApiUrls };
export default API;
